<!-- <template>
  <div v-if="!products.length">
    <p class="font-semibold text-sm">Keine Produkte gefunden</p>

  </div>
  <div v-else class="flex flex-wrap my-2 grid-400">
    <div
      class="relative md:p-4 lg:p-4 md:mb-3 lg:mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full bg-white product-grid-400 box-shadow"
      v-for="product in products"
      :key="product.id"
    >

     
      <div v-if="product.best_seller" class="absolute">
        <img class="w-16" src="./../../assets/images/best-seller.png" alt="Best Seller">
      </div>
      <WishlistPartials :product="product" @add-wishlist="addWishlist" class="wishlist-icon-400"/>
      <router-link :to="{ name: 'product', params: { id: product.id } }">
        <img
          v-if="product.product_image === null"
          class="h-auto w-full object-cover zoom-in"
          src="./../../assets/images/no-image.jpg"
          alt="No Image"
          
        />
        <img
          v-else
          class="h-auto w-full object-cover zoom-in"
          :src="product.product_image"
          alt="Product Image"
        />
      </router-link>
      
      <div class="flex flex-col py-4 text-400">
        <router-link :to="{ name: 'product', params: { id: product.id } }">
          <p class="text-base">{{ product.name }}</p>
        </router-link>
      </div>
        <div v-if="product.price>=0" class="text-center">
          <span class="font-medium text-teal-400 text-lg text-center pr-2 qmimi-400">{{ product.price | formatNumber }}</span>
        
          <span class="font-medium line-through  text-red-500 text-center qmimi-400">{{ product.old_price | formatNumber }}</span>
        </div>
        <div v-else>
          <p class="font-medium text-center">{{ product.old_price | formatNumber }}</p>
        </div>
      <div>

        <div v-show="windowWidth <= 450">
          <StarRating
        class="justify-center rating-400"
        :show-rating="false"
        :star-size="15"
        :read-only="true"
        v-model="product.ratings"
        ></StarRating>
      </div>

      <div v-show="windowWidth > 450">
          <StarRating
        class="justify-center rating-400"
        :show-rating="false"
        :star-size="25"
        :read-only="true"
        v-model="product.ratings"
        ></StarRating>
      </div> -->
<!-- 
    
    </div>
    
  </div>
  </div>
</template>

<script>
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from 'axios'
import WishlistPartials from '../../components/partials/wishlist/WishlistPartial'
import StarRating from "vue-star-rating";



export default {
  components: {
    // PulseLoader,
    WishlistPartials,
    StarRating
  },
  props: {
    products: Array,
    empty: Boolean,
  },
  data() {
    return {
      color: "",
      loading: "",
      size: "",
      windowWidth: window.innerWidth
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    addWishlist(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      
      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: id,
        button: 'ADD_TO_WISHLIST'
      })
      .catch(error => {
        console.log(error)
      })

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .post(`${process.env.VUE_APP_API}/wishlist`, {
          product_id: id,
        })
        .then(() => {
        
          if (!this.error) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Artikel in den Merkliste gelegt",
            });
          }
        })
        .catch((error) => {
          // console.log(error.response.data.error)
          if(error.response.status === 409) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: error.response.data.error,
            });
          }

          if(error.response.status === 401) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Nicht authentifiziert",
            });
          }
          this.error = true;
        }); 
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  }
};
</script> -->
<!-- 
<style scoped>
  /* .wishlit-icon {
    top: 10%;
    left: 80%;
  } */

  @media(max-width:450px){
    .product-grid-400{
      margin-bottom: 15px;
    }

    .grid-400{
      display: grid;
      grid-template-columns: repeat(2,1fr);
      gap: 10px;
    }
    .text-base{
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Limit to two lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 10px;
    }
    .text-400{
      padding-top: 8px;
      padding-bottom: 8px;
      height: 50px;
    }
    .qmimi-400{
      font-size: 15px;
      transform: translateY(-100px); /* Move up by 10 pixels */
    }
    .rating-400{
      font-size: 5px;
    }

    ::v-deep .wishlist-icon {
      /* Updated position and size for smaller screens */
     top: 1%;
     left: 80%;
    }
  }

  .box-shadow {
    width: 30%;
    margin-right: 10px ;
  transition: box-shadow 0.3s ease;
  transition: all 0.5s;
}

.box-shadow:hover {
  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.2);
  /* transform: translateY(-10px); */
}
.zoom-in {
  transition: transform 0.5s ease;
}

.zoom-in:hover {
  transform: scale(1.1);
}
</style> -->


<template class="product-grid-color">
  <div v-if="!products.length">
    <p class="font-semibold text-sm">Keine Produkte gefunden</p>
    <!-- <pulse-loader
      :loading="true"
      :color="'#4fd1c5'"
      :size="'15px'"
    ></pulse-loader> -->
  </div>
  <div v-else class="flex flex-wrap my-2 grid-400">
    <div
      class="relative md:p-4 lg:p-4 md:mb-3 lg:mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full bg-white product-grid-400 width-full-screen"
      v-for="product in products"
      :key="product.id"
    >
      <!-- <div v-if="product.old_price>0">
        <p class="font-medium line-through  text-red-500 float-right">{{ product.old_price | formatNumber }}</p>
        <p class="font-medium text-teal-400 text-lg">{{ product.price | formatNumber }}</p>
      </div> -->
     
      <div v-if="product.best_seller" class="absolute ">
        <img class="w-16" src="./../../assets/images/best-seller.png" alt="Best Seller">
      </div>
      <WishlistPartials :product="product" @add-wishlist="addWishlist" class="wishlist-icon-400"/>
      <router-link :to="{ name: 'product', params: { id: product.id } }">
        <img
          v-if="product.product_image === null"
          class="h-auto w-full object-cover img-style-new"
          src="./../../assets/images/no-image.jpg"
          alt="No Image"
        />
        <img
          v-else
          class="h-auto w-full object-cover img-style-new"
          :src="product.product_image"
          alt="Product Image"
        />
      </router-link>
      
      <div class="flex flex-col py-1 text-400 fixed-height">
        <router-link :to="{ name: 'product', params: { id: product.id } }">
          <p class="text-base">{{ product.name }}</p>
        </router-link>
      </div>
        <div v-if="product.price>=0" class="flex-new">
          <span class="font-medium text-teal-400 text-lg  pr-2  font-size-new">{{ product.price | formatNumber }}</span>
          <!-- <br> -->
          <span class="font-medium line-through  text-red-500  qmimi-400 font-size-new2">{{ product.old_price | formatNumber }}</span>
        </div>
        <div v-else>
          <p class="font-medium text-center">{{ product.old_price | formatNumber }}</p>
        </div>

        <div class="container-shporta-wishlist">
        
          <button class="cart-new-new" @click="getData(product.id);">
            {{ $t("AddToCart") }}
          </button>


        <p class="new-shporta2"></p>
        </div>

        <!--
      <div>

        <div v-show="windowWidth <= 450">
          <StarRating
        class="justify-center rating-400"
        :show-rating="false"
        :star-size="15"
        :read-only="true"
        v-model="product.ratings"
        ></StarRating>
      </div>

      <div v-show="windowWidth > 450">
          <StarRating
        class="justify-center rating-400"
        :show-rating="false"
        :star-size="25"
        :read-only="true"
        v-model="product.ratings"
        ></StarRating>
      </div>

    
    </div>
    -->
  </div>
  </div>
</template>

<script>
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from 'axios'
import WishlistPartials from '../../components/partials/wishlist/WishlistPartial'
import mixins from "@/mixins/mixins";





export default {
  components: {
    // PulseLoader,
    WishlistPartials,

   
  },
  props: {
    products: Array,
    empty: Boolean,
  },
   mixins: [mixins],
  data() {
    return {
      id: "",
      product: {},
      color: "",
      loading: "",
      size: "",
      windowWidth: window.innerWidth
    };
  },
  // watch: {
  //   '$route':function(){
  //     console.log(products);
  //   }
  //   // '$route': function() {
  //   //     this.getData(product.id);
  //   // }
  // },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
      
    
    getData(id) {
      console.log('1');
      axios
        .get(`${process.env.VUE_APP_API}/product/${id}`)
        .then((response) => {
          
          this.product = response.data.data;

          this.pdf = response.data.data.product_shop.product.pdf_file;

          this.code = response.data.data.product_shop.product.code;

          this.beschreibung =
            response.data.data.product_shop.product.attributes.beschreibung;
          
          // console.log(this.beschreibung);

          this.austtatung =
            response.data.data.product_shop.product.attributes.ausstatung;

          this.farbe = response.data.data.variants.farbe;

          this.dimensions = response.data.data.variants.dimensions;

          this.variants = response.data.data.variants.variants;

          // console.log(this.farbe);

          // console.log(this.dimensions);

          this.serie_products =
            response.data.data.product_shop.product.serie_products;

            this.short_name = response.data.data.product_shop.product.serie_products[0].productName;

          this.lieferInformation =
            response.data.data.product_shop.product.attributes.beschreibung.Lieferinformation.Lieferumfang;

          this.frontFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Front;

          this.korpusFarbe =
            response.data.data.product_shop.product.attributes.beschreibung.Farbe.Korpus;

          this.lightning = response.data.data.product_shop.product.lightning;

          this.rating = response.data.data.product_shop.product.rating;

          // this.productName = response.data.data.product_shop.product.name;
          this.productName = response.data.data.product_shop.name;

          // console.log('between');
          // console.log(response.data.data.product_shop.product)
          // console.log('between');
          this.addToCart(this.product);
        })
        .catch(error => {
          if(error.response.data == 'Nicht Gefunden!'){
            console.log(error.response.data);
            this.$router.push('/*');
          }

        });
    },
     addToCart(product) {
      console.log(product);

      let cart = JSON.parse(localStorage.getItem("cart")) || [];
      if (cart.length === 0) {
        console.log("JEMI NE PIKE");
        let item = {
          shopmarketplace_id: product.id,
          product_id: product.product_shop.product.id,
          product_name: product.product_shop.name,
          product_description: product.product_shop.name,
          sku: product.product_shop.product.skus[0].code,
          sale_price: product.price,
          shop_price: product.price,
          warehouse_price: product.price,
          vendor_price: product.price,
          amount: product.price,
          img: product.product_shop.product.product_image,
          lieferzeit: product.product_shop.product.skus[0].delivery_time,
          shop_name: product.product_shop.shop_name,
          stock: product.product_shop.product.stock,
          // subtotal: product.price * 1,
          qty: 1,
          shop_id: product.product_shop.shop_id,
          warehouse_id: product.product_shop.warehouse_id,
          vendor_id: product.product_shop.vendor_id,
          tax: "test",
          properties: "test",
          is_light: false,
        };
        cart.push(item);
        this.$store.commit("setCart", item);
        localStorage.setItem("cart", JSON.stringify(cart));
        this.$notify({
          group: "cart",
          title: "Cart",
          text: "Artikel in den Warenkorb gelegt",
        });
        console.log(cart);

      } else {
        let item = cart.find((item) => {
          return item.product_id === product.product_shop.product.id;
        });
        // console.log(item);
        if (item) {
          // check if is not new item
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Produkt ist bereits im Warenkorb vorhanden",
          });
        } else {
          let item = {
            shopmarketplace_id: product.id,
            product_id: product.product_shop.product.id,
            product_name: product.product_shop.name,
            product_description: product.product_shop.name,
            sku: product.product_shop.product.skus[0].code,
            sale_price: product.price,
            shop_price: product.price,
            warehouse_price: product.price,
            vendor_price: product.price,
            amount: product.price,
            img: product.product_shop.product.product_image,
            lieferzeit: product.product_shop.product.skus[0].delivery_time,
            shop_name: product.product_shop.shop_name,
            stock: product.product_shop.product.stock,
            // subtotal: product.price * 1,
            qty: 1,
            shop_id: product.product_shop.shop_id,
            warehouse_id: product.product_shop.warehouse_id,
            vendor_id: product.product_shop.vendor_id,
            tax: "test",
            properties: "test",
            is_light: false,
          };
          cart.push(item);
          this.$store.commit("setCart", item);
          localStorage.setItem("cart", JSON.stringify(cart));
          this.$notify({
            group: "cart",
            title: "Cart",
            text: "Artikel in den Warenkorb gelegt",
          });
        }
      }

      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: this.product.id,
        button: 'ADD_TO_CART'
      })
    },

    // addToCart(product) {
    //   axios.post(`${process.env.VUE_APP_API}/button-click`, {
    //     product_id: product.id,
    //     button: 'ADD_TO_CART'
    //   })
    //     .then(response => {
    //       // Handle the response from the backend
    //       const addedProduct = response.data;

    //       // Update the cart UI or perform any further actions
    //       console.log('Product added to cart:', addedProduct);
    //     })
    //     .catch(error => {
    //       // Handle any error that occurs during the API request
    //       console.error(error);
    //     });

    //     axios
    //     .get(`${process.env.VUE_APP_API}/product/${product.id}`)
    //     .then((response) => {
    //       console.log(response);
    //       this.product = response.data.data;
    //       // console.log(this.product);

    //       this.pdf = response.data.data.product_shop.product.pdf_file;

    //       this.code = response.data.data.product_shop.product.code;

    //       this.beschreibung =
    //         response.data.data.product_shop.product.attributes.beschreibung;
          
    //       // console.log(this.beschreibung);

    //       this.austtatung =
    //         response.data.data.product_shop.product.attributes.ausstatung;

    //       this.farbe = response.data.data.variants.farbe;

    //       this.dimensions = response.data.data.variants.dimensions;

    //       this.variants = response.data.data.variants.variants;

    //       // console.log(this.farbe);

    //       // console.log(this.dimensions);

    //       this.serie_products =
    //         response.data.data.product_shop.product.serie_products;

    //         this.short_name = response.data.data.product_shop.product.serie_products[0].productName;

    //       this.lieferInformation =
    //         response.data.data.product_shop.product.attributes.beschreibung.Lieferinformation.Lieferumfang;

    //       this.frontFarbe =
    //         response.data.data.product_shop.product.attributes.beschreibung.Farbe.Front;

    //       this.korpusFarbe =
    //         response.data.data.product_shop.product.attributes.beschreibung.Farbe.Korpus;

    //       this.lightning = response.data.data.product_shop.product.lightning;

    //       this.rating = response.data.data.product_shop.product.rating;

    //       // this.productName = response.data.data.product_shop.product.name;
    //       this.productName = response.data.data.product_shop.name;

    //       // console.log('between');
    //       // console.log(response.data.data.product_shop.product)
    //       // console.log('between');
    //     })
    //     .catch(error => {
    //       if(error.response.data == 'Nicht Gefunden!'){
    //         console.log(error.response.data);
    //         this.$router.push('/*');
    //       }

    //     });


    // },
    addWishlist(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      
      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: id,
        button: 'ADD_TO_WISHLIST'
      })
      .catch(error => {
        console.log(error)
      })

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .post(`${process.env.VUE_APP_API}/wishlist`, {
          product_id: id,
        })
        .then(() => {
        
          if (!this.error) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Artikel in den Merkliste gelegt",
            });
          }
        })
        .catch((error) => {
          // console.log(error.response.data.error)
          if(error.response.status === 409) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: error.response.data.error,
            });
          }

          if(error.response.status === 401) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Nicht authentifiziert",
            });
          }
          this.error = true;
        }); 
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  }
};
</script>



<style scoped>
  /* .wishlit-icon {
    top: 10%;
    left: 80%;
  } */

  .fixed-height{
    height: 40px;
    margin-bottom: 20px;
  }
  
  .wishlit-icon:hover{
    background-color:grey;
  }

  .text-base:hover{
    text-decoration: underline;
  }

.img-style-new{

  border-radius: 5px;

  transition: all 0.5s;
}
  .img-style-new:hover{
  scale: 1.05;
 }

  .flex-new{
    display:flex;
    flex-direction:column;
  }

  .font-size-new{
    font-size: 17px;
  }
  .font-size-new2{
    font-size:15px;
  }
  .container-shporta-wishlist{
    margin-top:3px;
    display:flex;
    justify-content:flex-start;
    
  }


  .new-shporta2{
    flex:1;
  }


 .cart-new-new{

  background-color: #efefefd9;
  border-radius: 5px;
  
  font-size: 12px;
  width: 100%;
  flex:3;
  margin-top: 15px;
  padding: 8px 0;
  border-radius: 5px;
  font-weight: 500;


  transition: all 0.2s;
 }

 .cart-new-new:hover{
  background-color: #4FD1C5;
  color: white;
 }


  .width-full-screen{
        width: 22%;
    margin-right: 24px;
    border:1px solid #f9f9f9;
    border-radius: 5px;

    transition: all 0.5s;
  }

  .width-full-screen:hover{
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 5px 5px rgba(0,0,0,0.1);
  }

  .text-base{
      display: -webkit-box;
      -webkit-line-clamp: 2; 
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 13px;
      margin-top:15px;
    }

  @media(max-width:450px){

 

    .font-size-new{
      margin-top: 10px;
      font-size: 14px;
    }

    .font-size-new2{
      font-size: 12px;
    }

    .width-full-screen{
    width: 100%;
    margin-right: 24px;
    border: 1px solid #f9f9f9;
    border-radius: 5px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    padding: 10px;
}

    .product-grid-400{
      margin-bottom: 15px;
    }

    .grid-400{
      display: grid;
      grid-template-columns: repeat(2,1fr);
      gap: 10px;
    }
    .text-base{
      display: -webkit-box;
      -webkit-line-clamp: 2; 
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 10px;
    }
    .text-400{
      padding-top: 8px;
      padding-bottom: 8px;
      height: 50px;
      margin-bottom: 5px;
    }
    
    .rating-400{
      font-size: 5px;
    }

    ::v-deep .wishlist-icon {
      
     top: 1%;
     left: 80%;
    }
  }

  




</style>
